import { ButtonDropdown, Flex, NavItem, Spacing, Text } from '@billy/design-system'
import { ReactElement, useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { BankTransactionSortProperty } from '@features/bankTransactions/enums/bankTransactionSortProperty'

import { SortDirection } from '../../../../../../../../enums/sortDirection'
import { useSandboxBankTransactionsFilters } from '../../../../hooks/useSandboxBankTransactionsFilters'

interface SortFilterDropdownValue {
  direction: SortDirection
  property: BankTransactionSortProperty
}

const getSortFilterId = (property: BankTransactionSortProperty, direction: SortDirection) => `${property}-${direction}`

export const BankTransactionsSorting = (): ReactElement => {
  const { t } = useTranslation()
  const [filters, setFilters] = useSandboxBankTransactionsFilters()

  const items: NavItem<SortFilterDropdownValue>[] = useMemo(
    () => [
      {
        children: t('bank_transactions.toolbar.sort_filter.date_desc'),
        id: getSortFilterId(BankTransactionSortProperty.EntryDate, SortDirection.Desc),
        value: { direction: SortDirection.Desc, property: BankTransactionSortProperty.EntryDate },
      },
      {
        children: t('bank_transactions.toolbar.sort_filter.date_asc'),
        id: getSortFilterId(BankTransactionSortProperty.EntryDate, SortDirection.Asc),
        value: { direction: SortDirection.Asc, property: BankTransactionSortProperty.EntryDate },
      },
    ],
    [t],
  )

  const handleSelect = useCallback(
    (_id: string, value: SortFilterDropdownValue) => {
      setFilters({ sortProperty: value.property, sortDirection: value.direction })
    },
    [setFilters],
  )

  return (
    <Flex gap={Spacing.S8} alignItems="center">
      <Text colorVariant="secondary" nowrap>
        {t('bank_transactions.toolbar.sort_filter.label')}
      </Text>
      <ButtonDropdown
        dropdownSize="xl"
        items={items}
        onSelect={handleSelect}
        selectedId={getSortFilterId(filters.sortProperty, filters.sortDirection)}
        variant="outlined"
        placement="bottom-start"
      />
    </Flex>
  )
}
